<br><br>
<div class="row  justify-content-center">
  <mat-card class="col-md-4">
    <form [formGroup]="forgotPasswordForm" style="text-align: center;">
      <img width="60%" height="25%" src="../../../../assets/images/ares-userlogo.png">
      <br><br>
      <h2>Forgot Password</h2>
      <div  *ngIf="!otpSend">
        <mat-form-field style="width: 100%;" >
            <mat-label>Email</mat-label>
            <input type="email" #emailInput id="emailInput" (blur)="onBlur($event)" matInput formControlName="email">
            <mat-error *ngIf="forgotPasswordForm?.get('email')?.errors?.required">
              Email is required
            </mat-error>
            <mat-error *ngIf="forgotPasswordForm?.get('email')?.errors?.pattern">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>
      </div>
      
      <mat-form-field style="width: 100%;" *ngIf="otpSend" >
        <mat-label>Password</mat-label>
        <input type="password" matInput formControlName="password">
        <mat-error *ngIf="forgotPasswordForm.get('password').errors?.required">
          Password is required
        </mat-error>
      </mat-form-field>
      <mat-form-field style="width: 100%;" *ngIf="otpSend" >
        <mat-label>Confirm Password</mat-label>
        <input type="password" matInput formControlName="confirmPassword"  >
      </mat-form-field>
      <mat-form-field style="width: 100%;"  *ngIf="otpSend">
        <mat-label>6 Digit Verification Code</mat-label>
        <input type="number" matInput formControlName="otp">
      </mat-form-field>
    </form>
    
    <div class="form-group" style="text-align: center;">
      <button class="btn btn-primary" style="margin-right: 10px;" (click)="login()">
        Back
      </button>
      <button [disabled]="loading" class="btn btn-primary" (click)="forgotPassword()" *ngIf="!otpSend">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        Send OTP
      </button>
      <button [disabled]="loading" class="btn btn-primary" style="margin-right: 10px;" (click)="verifyOtp()" *ngIf="otpSend">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        Verify
      </button>
      <button [disabled]="loading" class="btn btn-primary" (click)="resendOtp()" *ngIf="otpSend">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Resend
        </button>
    </div>
    <br><br>
  </mat-card>
</div>
